import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap'
import FormNotificar from '../components/FormNotificar'

const ModalNotificar = ({ isOpen, closeModal, user }) => {

    const _user = (user == null) ? { Nombre: "", idUsuario: 0 } : user

    return(
        <Modal
            isOpen={isOpen}
        >
            <ModalHeader>Notificar Usuario</ModalHeader>
            <ModalBody>
                <h6>Notificar a: {_user.Nombre}</h6>
                <FormNotificar idUsuario={_user.idUsuario} />
                <Button onClick={closeModal} color='danger' className='mt-2' size='lg' block>Cancelar</Button>
            </ModalBody>
        </Modal>
    )
}

export default ModalNotificar